import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { scrollbarBase, truncateTextStyle } from '../../../../styles/styles';

const { colors } = THEME;

const clickable = {
	':active': {
		opacity: 0.7,
	},
	transition: 'opacity 0.1s',
	width: 50,
};

const textLink = {
	color: colors.text.dark,
	textDecoration: 'none',
	':hover': {
		textDecoration: 'underline',
		color: colors.primary.main,
	},
};

export const styleSheet = StyleSheet.create({
	avatar: {
		cursor: 'pointer',
		flexShrink: 0,
		opacity: 1,
		...clickable,
	},
	containerSelected: {
		background: '#f3f6f8',
	},
	extraTags: {
		padding: 8,
		borderRadius: 8,
		maxHeight: 300,
		overflowY: 'auto',
		overflowX: 'hidden',
		borderColor: colors.border.main,
		display: 'flex',
		flexWrap: 'wrap',
		gap: '0.5rem',
		maxWidth: 300,
		...scrollbarBase,
	},
	extraTagsItem: {
		display: 'flex',
	},
	infoPopover: {
		borderColor: colors.border.main,
	},
	infoTitle: {
		color: colors.text.dark,
	},
	nameColumn: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: '0.5rem',
		minWidth: 0,
	},
	nameContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: '0.5rem',
		maxWidth: 400,
	},
	contactInfoDrawerButton: {
		padding: 0,
	},
	contactInfoDrawerIcon: {
		transform: 'rotate(-90deg)',
		margin: '0 !important',
	},
	nameWrapper: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: 'min-content',
	},
	outerContainer: {
		background: '#fff',
		cursor: 'pointer',
		transition: 'background 0.1s',
	},
	tagsColumn: {
		display: 'flex',
		gap: '0.5rem',
	},
	tag: {
		display: 'inline-flex',
	},
	tagMore: {
		fontSize: 12,
	},
	subtitle: {
		display: 'inline-block',
		color: colors.icon.gray,
		fontSize: 12,
		maxWidth: 500,
		...truncateTextStyle,
	},
	contactLink: {
		margin: 0,
		color: colors.primary.main,
		fontWeight: 600,
		fontSize: 'inherit',
		maxWidth: 400,
		':hover': {
			color: colors.hover.main,
		},
	},
	iconPlaceholder: {
		width: 21,
	},
	infoLink: {
		fontSize: 14,
		...textLink,
	},
	defaultCell: {
		fontSize: 14,
		color: colors.text.dark,
	},
});
